module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "july"
    }
  }, [_c('h2', [_vm._v("July")]), _vm._v(" "), _c('p', [_vm._v("The summer heat")]), _vm._v(" "), _c('p', [_vm._v("Hanging heavy in the air")]), _vm._v(" "), _c('p', [_vm._v("Peonies on the table")]), _vm._v(" "), _c('p', [_vm._v("Opening at a languid pace")]), _vm._v(" "), _c('p', [_vm._v("White cotton sheets")]), _vm._v(" "), _c('p', [_vm._v("Rumpled on the bed")]), _vm._v(" "), _c('p', [_vm._v("The sound of your footsteps")]), _vm._v(" "), _c('p', [_vm._v("Tracing the hardwood floor")]), _vm._v(" "), _c('p', [_vm._v("The hands of the broken clock")]), _vm._v(" "), _c('p', [_vm._v("Standing silently in place")]), _vm._v(" "), _c('p', [_vm._v("The promise of what could be")]), _vm._v(" "), _c('p', [_vm._v("As eternal as those summer days.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd51864a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0006.vue
// module id = 96
// module chunks = 0